import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{! template-lint-disable no-pointer-down-event-binding }}
<DModal
  {{on "keydown" this.keyDown}}
  {{on "mousedown" this.mouseDown}}
  @closeModal={{@closeModal}}
  @title={{i18n "composer.link_dialog_title"}}
  @bodyClass="insert-link"
  class="insert-hyperlink-modal"
>
  <:body>
    <div class="inputs">
      <input
        {{on "input" this.search}}
        value={{this.linkUrl}}
        placeholder={{i18n "composer.link_url_placeholder"}}
        type="text"
        autofocus="autofocus"
        class="link-url"
      />

      {{#if this.searchLoading}}
        {{loading-spinner}}
      {{/if}}

      {{#if this.searchResults}}
        <div class="internal-link-results">
          {{#each this.searchResults as |result|}}
            <a
              {{on "click" this.linkClick}}
              href={{result.url}}
              data-title={{result.fancy_title}}
              class="search-link"
            >
              <TopicStatus @topic={{result}} @disableActions={{true}} />
              {{replace-emoji result.title}}
              <div class="search-category">
                {{#if result.category.parentCategory}}
                  {{category-link result.category.parentCategory}}
                {{/if}}
                {{category-link result.category hideParent=true}}
                {{discourse-tags result}}
              </div>
            </a>
          {{/each}}
        </div>
      {{/if}}
    </div>

    <div class="inputs">
      <input
        {{on "input" this.updateLinkText}}
        value={{this.linkText}}
        placeholder={{i18n "composer.link_optional_text"}}
        type="text"
        class="link-text"
      />
    </div>
  </:body>

  <:footer>
    <DButton
      @action={{this.ok}}
      @label="composer.modal_ok"
      type="submit"
      class="btn-primary"
    />

    <DButton
      @action={{@closeModal}}
      @label="composer.cancel"
      class="btn-danger"
    />
  </:footer>
</DModal>
*/
{
  "id": "XyiESyHW",
  "block": "[[[8,[39,0],[[24,0,\"insert-hyperlink-modal\"],[4,[38,2],[\"keydown\",[30,0,[\"keyDown\"]]],null],[4,[38,2],[\"mousedown\",[30,0,[\"mouseDown\"]]],null]],[[\"@closeModal\",\"@title\",\"@bodyClass\"],[[30,1],[28,[37,1],[\"composer.link_dialog_title\"],null],\"insert-link\"]],[[\"body\",\"footer\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"inputs\"],[12],[1,\"\\n      \"],[11,\"input\"],[16,2,[30,0,[\"linkUrl\"]]],[16,\"placeholder\",[28,[37,1],[\"composer.link_url_placeholder\"],null]],[24,\"autofocus\",\"autofocus\"],[24,0,\"link-url\"],[24,4,\"text\"],[4,[38,2],[\"input\",[30,0,[\"search\"]]],null],[12],[13],[1,\"\\n\\n\"],[41,[30,0,[\"searchLoading\"]],[[[1,\"        \"],[1,[34,4]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"searchResults\"]],[[[1,\"        \"],[10,0],[14,0,\"internal-link-results\"],[12],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[30,0,[\"searchResults\"]]],null]],null],null,[[[1,\"            \"],[11,3],[16,6,[30,2,[\"url\"]]],[16,\"data-title\",[30,2,[\"fancy_title\"]]],[24,0,\"search-link\"],[4,[38,2],[\"click\",[30,0,[\"linkClick\"]]],null],[12],[1,\"\\n              \"],[8,[39,7],null,[[\"@topic\",\"@disableActions\"],[[30,2],true]],null],[1,\"\\n              \"],[1,[28,[35,8],[[30,2,[\"title\"]]],null]],[1,\"\\n              \"],[10,0],[14,0,\"search-category\"],[12],[1,\"\\n\"],[41,[30,2,[\"category\",\"parentCategory\"]],[[[1,\"                  \"],[1,[28,[35,9],[[30,2,[\"category\",\"parentCategory\"]]],null]],[1,\"\\n\"]],[]],null],[1,\"                \"],[1,[28,[35,9],[[30,2,[\"category\"]]],[[\"hideParent\"],[true]]]],[1,\"\\n                \"],[1,[28,[35,10],[[30,2]],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[2]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"inputs\"],[12],[1,\"\\n      \"],[11,\"input\"],[16,2,[30,0,[\"linkText\"]]],[16,\"placeholder\",[28,[37,1],[\"composer.link_optional_text\"],null]],[24,0,\"link-text\"],[24,4,\"text\"],[4,[38,2],[\"input\",[30,0,[\"updateLinkText\"]]],null],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],[[[1,\"\\n    \"],[8,[39,11],[[24,0,\"btn-primary\"],[24,4,\"submit\"]],[[\"@action\",\"@label\"],[[30,0,[\"ok\"]],\"composer.modal_ok\"]],null],[1,\"\\n\\n    \"],[8,[39,11],[[24,0,\"btn-danger\"]],[[\"@action\",\"@label\"],[[30,1],\"composer.cancel\"]],null],[1,\"\\n  \"]],[]]]]]],[\"@closeModal\",\"result\"],false,[\"d-modal\",\"i18n\",\"on\",\"if\",\"loading-spinner\",\"each\",\"-track-array\",\"topic-status\",\"replace-emoji\",\"category-link\",\"discourse-tags\",\"d-button\"]]",
  "moduleName": "discourse/components/modal/insert-hyperlink.hbs",
  "isStrictMode": false
});